import type { CSSProperties } from 'react'

/**
 * Where a marker sits on its track, and the number its entrance slides from: `animate-track-marker`
 * (globals.css) starts the marker `--at` percent of the track to the left and lands it on `left`.
 * The track, or a row laid over it, must be `@container`, because the slide is measured in `cqw`.
 */
export function trackMarkerStyle(percent: number): CSSProperties {
  return { left: `${percent.toFixed(3)}%`, ['--at' as string]: percent }
}
